<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/sede']"
              >Unidade Sede</a
            >
          </div>
          <h1 class="title text-white">Conheça a Sede</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      A sede da Faculdade Facint está localizada na Rua Piratininga, nº 813, 1º
      andar, no município de Maringá – PR. O campus oferece uma infraestrutura
      moderna e funcional, com salas de aula equipadas, laboratórios
      especializados, biblioteca com acervo atualizado, espaços de convivência e
      uma estrutura administrativa organizada para garantir suporte acadêmico e
      institucional de qualidade. Tudo foi pensado para proporcionar um ambiente
      acolhedor, seguro e propício à aprendizagem, tanto para estudantes quanto
      para docentes e colaboradores.
    </p>
  </div>
</div>
